import ToggleExample from "./examples/Toggle.Example";

export default [
    {
        title: "Basic toggle",
        component: ToggleExample,
        code: require("!raw-loader!./examples/Toggle.Example.tsx")
    }
];
